import React, { createContext, useContext, useState, ReactNode } from "react";

interface SignUpData {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  city?: string;
  password?: string;
  confirm_password?: string;
  referral_code?: string
    business_name?: string;
  website?: string;
  business_type?: string;
  business_category?: string;

}

interface SignupContextType {
  signupData: SignUpData;
  setSignUpData: React.Dispatch<React.SetStateAction<SignUpData>>;
}

const SignupContext = createContext<SignupContextType | undefined>(undefined);

export const SignUpProvider = ({ children }: { children: ReactNode }) => {
  const [signupData, setSignUpData] = useState<SignUpData>({});
  return (
    <SignupContext.Provider value={{ signupData, setSignUpData }}>
      {children}
    </SignupContext.Provider>
  );
};

export const useSignUp = () => {
  const context = useContext(SignupContext);
  if (!context) throw new Error("useSignUp must be used within SignupProvider");
  return context;
};
